import { render, staticRenderFns } from "./DataDictionary.vue?vue&type=template&id=049b9170&scoped=true&"
import script from "./DataDictionary.vue?vue&type=script&lang=js&"
export * from "./DataDictionary.vue?vue&type=script&lang=js&"
import style0 from "./DataDictionary.vue?vue&type=style&index=0&id=049b9170&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049b9170",
  null
  
)

export default component.exports